<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Edit Protectometer Master
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text style="margin-top:10px">
                <v-form
                  ref="submitForm"
                  v-model="valid"
                  @submit.prevent="submitForm"
                  lazy-validation
                >
                <v-text-field
                  v-model="max_monthly_living_expense"
                  label="Max Monthly Living Expense"
                  name="max_monthly_living_expense"
                  id="max_monthly_living_expense"
                ></v-text-field>

                <v-text-field
                  v-model="max_annual_living_expense"
                  label="Max Annual Living Expense"
                  name="max_annual_living_expense"
                  id="max_annual_living_expense"
                ></v-text-field>

                <v-text-field
                  v-model="pre_retirement_expense_proportion"
                  label="Pre Retirement Expense Proportion"
                  name="pre_retirement_expense_proportion"
                  id="pre_retirement_expense_proportion"
                ></v-text-field>  

                <v-text-field
                  v-model="post_retirement_expense_proportion"
                  label="Post Retirement Expense Proportion"
                  name="post_retirement_expense_proportion"
                  id="post_retirement_expense_proportion"
                ></v-text-field> 


                <v-text-field
                  v-model="life_expectancy"
                  label="Life Expectancy"
                  name="life_expectancy"
                  id="life_expectancy"
                ></v-text-field> 

                <v-text-field
                  v-model="growth_rate_of_max_annual_living_expense"
                  label="Growth Rate Of Max Annual Living Expense"
                  name="growth_rate_of_max_annual_living_expense"
                  id="growth_rate_of_max_annual_living_expense"
                ></v-text-field> 

                <v-text-field
                  v-model="pre_retirment_income_growth"
                  label="Pre Retirment Income Growth"
                  name="pre_retirment_income_growth"
                  id="pre_retirment_income_growth"
                ></v-text-field>

                <v-text-field
                  v-model="post_retirment_income_growth"
                  label="Post Retirment Income Growth"
                  name="post_retirment_income_growth"
                  id="post_retirment_income_growth"
                ></v-text-field>

                <v-text-field
                  v-model="current_g_sec_rate"
                  label="Current G Sec Rate"
                  name="current_g_sec_rate"
                  id="current_g_sec_rate"
                ></v-text-field>

                <v-text-field
                  v-model="avg_income_rate"
                  label="Avg Income Rate"
                  name="avg_income_rate"
                  id="avg_income_rate"
                ></v-text-field>

                <v-text-field
                  v-model="education_inflation"
                  label="Education Inflation"
                  name="education_inflation"
                  id="education_inflation"
                ></v-text-field>

                <v-text-field
                  v-model="income_replacement_till_age"
                  label="Income Replacement Till Age"
                  name="income_replacement_till_age"
                  id="income_replacement_till_age"
                ></v-text-field>

                <v-text-field
                  v-model="age_2_or_less_than_2"
                  label="Amout (Age Two or Less Than Two)"
                  name="age_2_or_less_than_2"
                  id="age_2_or_less_than_2"
                ></v-text-field>

                <v-text-field
                  v-model="class_kg"
                  label="Amout (Class KG)"
                  name="class_kg"
                  id="class_kg"
                ></v-text-field>

                <v-text-field
                  v-model="class_v"
                  label="Amout (Class V)"
                  name="class_v"
                  id="class_v"
                ></v-text-field>

                <v-text-field
                  v-model="class_x"
                  label="Amout (Class X)"
                  name="class_x"
                  id="class_x"
                ></v-text-field>

                <v-text-field
                  v-model="class_higher_secondary"
                  label="Amout (Class Higher Secondary)"
                  name="class_higher_secondary"
                  id="class_higher_secondary"
                ></v-text-field>

                <v-text-field
                  v-model="class_graduation"
                  label="Amout (Cass Graduation)"
                  name="class_graduation"
                  id="class_graduation"
                ></v-text-field>

                <v-text-field
                  v-model="class_post_graduation"
                  label="Amout (Cass Post Graduation)"
                  name="class_post_graduation"
                  id="class_post_graduation"
                ></v-text-field>

                <v-text-field
                  v-model="class_mphil"
                  label="Amout (Class Mphil)"
                  name="class_mphil"
                  id="class_mphil"
                ></v-text-field>

                <v-text-field
                  v-model="start_of_life"
                  label="Amout (Start Of Life)"
                  name="start_of_life"
                  id="start_of_life"
                ></v-text-field>

                <v-text-field
                  v-model="anual_expense_till_age_60"
                  label="Anual Expense Till Age 60"
                  name="anual_expense_till_age_60"
                  id="anual_expense_till_age_60"
                ></v-text-field> 

                <v-text-field
                  v-model="anual_expense_till_age_70"
                  label="Anual Expense Till Age 70"
                  name="anual_expense_till_age_70"
                  id="anual_expense_till_age_70"
                ></v-text-field> 

                <v-text-field
                  v-model="anual_expense_till_age_80"
                  label="Anual Expense Till Age 80"
                  name="anual_expense_till_age_80"
                  id="anual_expense_till_age_80"
                ></v-text-field> 

                <v-text-field
                  v-model="expense_growth"
                  label="Expense Growth"
                  name="expense_growth"
                  id="expense_growth"
                ></v-text-field> 

                <v-text-field
                  v-model="life_expectancy_parents"
                  label="Life Expectancy Parents"
                  name="life_expectancy_parents"
                  id="life_expectancy_parents"
                ></v-text-field>      

                <v-btn
                  :disabled="!valid"
                  color="warning"
                  class="mr-4"
                  type="submit"
                >Update</v-btn>
                </v-form>   
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>    
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    search: '',
    file:'',
    delete_pic:'',
    formDialog:false,
    max_monthly_living_expense:'',
    max_annual_living_expense:'',
    pre_retirement_expense_proportion:'',
    post_retirement_expense_proportion:'',
    life_expectancy:'',
    growth_rate_of_max_annual_living_expense:'',
    pre_retirment_income_growth:'',
    post_retirment_income_growth:'',
    current_g_sec_rate:'',
    avg_income_rate:'',
    education_inflation:'',
    income_replacement_till_age:'',
    id:'',
    age_2_or_less_than_2:'',
    class_kg:'',
    class_v:'',
    class_x:'',
    class_higher_secondary:'',
    class_graduation:'',
    class_post_graduation:'',
    class_mphil:'',
    start_of_life:'',
    anual_expense_till_age_60:'',
    anual_expense_till_age_70:'',
    anual_expense_till_age_80:'',
    expense_growth:'',
    life_expectancy_parents:''
  }),

  created() {
    this.initialize();
  },
  mounted() {},

  watch: {
    referral_code(val){
      this.referral_code = val.toUpperCase();
    }  
  },

  methods: {
  	importDialog(){
    	this.importFormDialog = true
    },

    initialize() {
      this.items = [];
      let token = localStorage.getItem("token");
      axios.get(process.env.VUE_APP_ROOT_API + "admin/get-protectometer-master-data", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        this.max_monthly_living_expense=response.data.data.max_monthly_living_expense;
        this.max_annual_living_expense=response.data.data.max_annual_living_expense;
        this.pre_retirement_expense_proportion=response.data.data.pre_retirement_expense_proportion;
        this.post_retirement_expense_proportion=response.data.data.post_retirement_expense_proportion;
        this.life_expectancy=response.data.data.life_expectancy;
        this.growth_rate_of_max_annual_living_expense=response.data.data.growth_rate_of_max_annual_living_expense;
        this.pre_retirment_income_growth=response.data.data.pre_retirment_income_growth;
        this.post_retirment_income_growth=response.data.data.post_retirment_income_growth;
        this.current_g_sec_rate=response.data.data.current_g_sec_rate;
        this.avg_income_rate=response.data.data.avg_income_rate;
        this.education_inflation=response.data.data.education_inflation;
        this.income_replacement_till_age=response.data.data.income_replacement_till_age;
        this.id = response.data.data.id;
        this.age_2_or_less_than_2=response.data.data.age_2_or_less_than_2;
        this.class_kg=response.data.data.class_kg;
        this.class_v=response.data.data.class_v;
        this.class_x=response.data.data.class_x;
        this.class_higher_secondary=response.data.data.class_higher_secondary;
        this.class_graduation=response.data.data.class_graduation;
        this.class_post_graduation=response.data.data.class_post_graduation;
        this.class_mphil=response.data.data.class_mphil;
        this.start_of_life=response.data.data.start_of_life;
        this.anual_expense_till_age_60=response.data.data.anual_expense_till_age_60;
        this.anual_expense_till_age_70=response.data.data.anual_expense_till_age_70;
        this.anual_expense_till_age_80=response.data.data.anual_expense_till_age_80;
        this.expense_growth=response.data.data.expense_growth;
        this.life_expectancy_parents=response.data.data.life_expectancy_parents;
      });
    },





    submitForm(){
      if(this.$refs.submitForm.validate() !=false){
        this.$loading(true)
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("id", this.id);
        formdata.append("max_monthly_living_expense", this.max_monthly_living_expense);
        formdata.append("max_annual_living_expense", this.max_annual_living_expense);
        formdata.append("pre_retirement_expense_proportion", this.pre_retirement_expense_proportion);
        formdata.append("post_retirement_expense_proportion", this.post_retirement_expense_proportion);
        formdata.append("life_expectancy", this.life_expectancy);
        formdata.append("growth_rate_of_max_annual_living_expense", this.growth_rate_of_max_annual_living_expense);
        formdata.append("pre_retirment_income_growth", this.pre_retirment_income_growth);
        formdata.append("post_retirment_income_growth", this.post_retirment_income_growth);
        formdata.append("current_g_sec_rate", this.current_g_sec_rate);
        formdata.append("avg_income_rate", this.avg_income_rate);
        formdata.append("education_inflation", this.education_inflation);
        formdata.append("income_replacement_till_age", this.income_replacement_till_age);

        formdata.append("age_2_or_less_than_2", this.age_2_or_less_than_2);
        formdata.append("class_kg", this.class_kg);
        formdata.append("class_v", this.class_v);
        formdata.append("class_x", this.class_x);
        formdata.append("class_higher_secondary", this.class_higher_secondary);
        formdata.append("class_graduation", this.class_graduation);
        formdata.append("class_post_graduation", this.class_post_graduation);
        formdata.append("class_mphil", this.class_mphil);
        formdata.append("start_of_life", this.start_of_life);
        formdata.append("anual_expense_till_age_60", this.anual_expense_till_age_60);
        formdata.append("anual_expense_till_age_70", this.anual_expense_till_age_70);
        formdata.append("anual_expense_till_age_80", this.anual_expense_till_age_80);
        formdata.append("expense_growth", this.expense_growth);
        formdata.append("life_expectancy_parents", this.life_expectancy_parents);
        
        axios.post( process.env.VUE_APP_ROOT_API+'update-protectometer-master-data',
          formdata,{
            headers: {
              'Access-Control-Allow-Origin':'*'
            }
          }
        ).then((response) => { 
          this.data_items = this.all_data_items = response.data.data;
          swal.fire({
            title: '',
            text: "Data Updated Successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              this.formDialog = false
            }
          })
          this.$loading(false)    
        }).catch(() => {this.$loading(false) }); 
      }
    },

    filterData(e){
    	this.data_items = []
      this.all_data_items.forEach(item => {
      	if(item.depository_type == e){
          this.data_items.push(item);
      	}
      });
    },

    editItem(item){
      this.qusDetail = item.qus
      this.ansDetail   = item.ans
      this.qusId   = item.qusId
      this.ansId           = item.id
      this.markDetail = item.mark
      this.formDialog        = true
    },

    back(){
      this.$router.push({
        name: 'MasterIndex',
        params: {},
      });
    },

    submitUploadFileForm(){
    	this.$loading(true)
    	let formdata    = new FormData();
    	formdata.append("file", document.getElementById("file").files[0]);
    
    	axios.post( process.env.VUE_APP_ROOT_API+'store-stock-broker',
        formdata,{
          headers: {
          	'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin':'*'
          },
        },
      ).then((response) => { 
      	this.$loading(false)
      	swal.fire({
            title: '',
            text: "Data Imported Successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
            	this.importFormDialog = false

              this.initialize();
            }
          })
      }).catch(() => {this.$loading(false) }); 
    },

    downloadSample(){
    	let formdata    = new FormData();
      formdata.append("type", 'stock_broker');
      axios.post( process.env.VUE_APP_ROOT_API+'download-sample-file',
        formdata,{
          headers: {
            'Access-Control-Allow-Origin':'*'
          },
          responseType: 'blob',
        },
      ).then((response) => { 
      	const url = URL.createObjectURL(new Blob([response.data]))
		    const link = document.createElement('a')
		    link.href = url
		    link.setAttribute(
		      'download',
		      `stock_broker_sample.csv`
		    )
		    document.body.appendChild(link)
		    link.click()
         
      }).catch(() => {this.$loading(false) }); 
    }
  },
};
</script>
<style>
	.compaign-container {
	  margin-top: 0px;
	  float: left;
	}
	.active-class {
	  color: rgb(35, 199, 35);
	  font-size: 16px;
	  font-weight: bold;
	}
	.inactive-class {
	  font-size: 16px;
	  font-weight: bold;
	  color: dimgrey;
	}


</style>
